import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { I as Icon } from '../../Icon/Icon-QOd-wyJ6.js';
import { P as PaginationButton } from './PaginationButton-Bhs94nl1.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { b as angleInlineEnd } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-sBnDaVj5-23EprBeB.js';

const PaginationNextButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-next-button')
}, props), /*#__PURE__*/React__default.createElement(Icon, {
  type: angleInlineEnd,
  blockSize: true
}));
PaginationNextButton.displayName = 'PaginationNextButton';

export { PaginationNextButton as P };
//# sourceMappingURL=PaginationNextButton-BLYjgHLD.js.map
